export default {
  FormImport: require('./FormImport').default,
  FormImportFeedback: require('./FormImportFeedback').default,
  HistoryImport: require('./HistoryImport.vue').default,
  HistoryImportTPM: require('./HistoryImportTPM.vue').default
}
